import React, { Component } from "react";
import InputMask from "react-input-mask";
import $ from "jquery";

export default class CampoNroTelefono extends Component {

  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  };
  componentDidMount() {

  }

  onChange = (event) => {
    this.props.phoneSelectorValue(event.target.value);
  }

  render() {
   
    return ( 
            <div className="form-group">
              <label className="input-label-bold">{this.props.label}</label>                        
              <InputMask id="telefono" name="telefono" type="text" mask="(0\999)999-999" placeholder="(09**)999-999" defaultValue={this.props.phoneSelector}
                className="form-control input-box" onBlur={this.onChange} required disabled={this.props.disabled}>
              </InputMask>
            </div>

    );
  }
}

